module.exports = __webpack_public_path__ + "img/12px-edit-white.2feda377.svg";